import { environment as defaultEnvironment } from './config';

export const environment = {
  ...defaultEnvironment,
  webchatBaseURL: 'https://webchat.helplinesoftware.com',
  production: true,
};
